import * as React from 'react';
import { Search as SearchIcon } from '@mui/icons-material';
import { CircularProgress, InputAdornment, TextField } from '@mui/material';
import debounce from 'lodash/debounce';


interface DocumentFileSearchBoxProps {
  onSearch: (search: string) => void;
  loading: boolean;
  error?: string | null;
}

export function DocumentFileSearchBox({ onSearch, loading, error }: DocumentFileSearchBoxProps): React.JSX.Element {
  const [search, setSearch] = React.useState('');

  const debouncedOnSearch = React.useCallback(
    debounce((search: string) => {
      onSearch(search);
    }, 300),
    [onSearch]
  );

  const handleSearch = (search: string) => {
    setSearch(search);
    if (search === '') {
      onSearch(search);
      return;
    }
    debouncedOnSearch(search);
  };

  return (
    <TextField
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment: loading ? (
          <InputAdornment position="end">
            <CircularProgress size={20} />
          </InputAdornment>
        ) : null,
      }}
      onChange={(e) => { handleSearch(e.target.value); }}
      placeholder="Search files..."
      type="search"
      value={search}
    />
  );
}
